
import { useState } from 'react';
// import { useContext } from 'react';

// import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import "./certificados.css";
// import ALink from '../../components/ALink';
import Header from '../../components/Header';
import MFooter from '../../components/MFooter'
import {Error} from '../../components/Erro';

import useFind from '../../hooks/useFind'
import {useFetch} from '../../hooks/useFetch'
import useForm from '../../hooks/useForm';

import {PopUpConteiner} from "./PopUpConteiner";

import {LoadingV2} from '../../components/Loading';
import FormInput from '../../components/FormInput';
import BtnDj from '../../components/Btn_dj'
// import { UserContext } from '../../hooks/UserContext';

import {
	// BtnBaixarSalvarCertificado,
	// BaixarSalvarCertificado,
	getUrlIcone
} from "./index";

// const img_generica = "/generico/g_extra..svg"

export default function Main(){
	const params = useParams();
	return (
	  <>
	    {/* menu superior do dj*/}
	    <Header/>
	    {/*Conteudo*/}
			<main className="ofc-main">
				<MainBody params={params}/>
			</main>
	    {/*Rodape*/}
	    <MFooter/>
	  </>
	);
};

function MainBody({params}){
  const {certificado_id} = params;

	// const {data: oficina_data, } = useFind('oficinas');

	// const {data:certi_data, isLoading, error} =
	// 	useFind(`/user/reinvidicar_certificado/${certificado_id}` )

	const {data:certificado_data, isLoading, error} =
			useFind(`user/reivindicar_certificado/${certificado_id}`)

	if (error){
		return (
			<PopUpConteiner>
				{!!error.messages
					? <Error error={error.messages}/>
					: <Error error={`${error}`}/>}
			</PopUpConteiner>
		)
	}
	if (!certificado_data){
		return (
			<PopUpConteiner>
				<Error error={`Erro ao carregar`}/>
			</PopUpConteiner>
		)
	}
	if (isLoading){
		return <PopUpConteiner style={{minHeight: "70vh"}}>
			<LoadingV2/>
		</PopUpConteiner>
	}

	// const oficina = oficina_data.find(o=>o.id===certificado_data.oficina_id)||{};
	const {certificado:meu_certificado} = certificado_data;
	const {oficina} = meu_certificado

	// ------------------
	const {
		titulo, texto, icone,nome,
	} = {
		titulo : `Certificado` ,
		texto : `${oficina.nome}` ,
		icone : getUrlIcone({oficina}),//oficina.url_icone||img_generica,
		// icone : img_generica,
		nome: meu_certificado.nome
	}
	// ------------- avivos
	const aviso_reivindicado = meu_certificado.user_id
		? `✔ Este certificado já foi associado a uma conta InovOnline`
		: `❌ Este certificado ainda não foi associado a uma conta InovOnline`
	const aviso_baixado = meu_certificado.baixado
		? `✔ Este certificado já foi baixado pelo menos uma vez`
		: `❌ Este certificado nunca foi baixado`

	// ------------- botões
	// const btns = <BtnBaixarSalvarCertificado certificado_id={certificado_id}/>

	// const src_icone = process.env.PUBLIC_URL+"/img/mundos_logo/"+(icone)
  return (
		<PopUpConteiner>
			<h1 className="popup-titulo">{titulo}</h1>
			<div className="popup-bloco">
				{ (!!icone && icone!=="/img/#")
					&& <img alt={`ícone da oficina`} src={icone} className="certificados-icon"/>
				}
				<div className="popup-bloco-texto">
					<h2 className="popup-h2">{texto}</h2>
				</div>
			</div>
			<div className="popup-texto">
				<p>{"Este certificado pertence a:"}</p>
				<h2 className="popup-h2">{nome}</h2>
			</div>

			<NavMenu {...{certificado_id}}/>

			<ul className="popup-aviso">
				<li>{aviso_reivindicado}</li>
				<li>{aviso_baixado}</li>
				{/* Baixar Certificado
				{meu_certificado.url} */}
			</ul>
		</PopUpConteiner>
	)
}

function NavMenu({certificado_id}){
	// busca usuário no contexto (verifica se foi logado)
  // const { user, isLoading } = useContext(UserContext);
  const { data, error} = useFetch("/user");
	const modo = {stts:"carregando", user:null}

	if (error&&error.response.status===401){
		modo.stts="desconectado"
		modo.user=null
	}
	if (!data&&!error){
		return  <LoadingV2 texto="Verificando usuário conectado"/>
	}
	if (data){
		// const {currentUser:user} = ;
		modo.user = data.currentUser;
	}

	//  Usuario não conectado
	// console.log({user:modo.user})
	if (!modo.user){
		return <div className="popup-aviso centralizar">
			<p>{"Faça login para conseguir baixar o certificado"}</p>
			<BtnDj to="/Login" texto="Fazer Login"/>
			<p>{"Ainda não tem uma conta?"}</p>
			<BtnDj to="/Cadastrar" texto="Matricular-me"/>
		</div>
	}

	return <BtnReivindicarBaixarSalvarCertificado certificado_id={certificado_id}/>

}


function BtnReivindicarBaixarSalvarCertificado({certificado_id,/*setBaixar*/}){
	const [baixar, setBaixar] = useState(false)
	// const [reivindicar, setReivindicar] = useState(false)
	  const { values, handleChange} = useForm({
			initialValues: {
				reivindicar:true,
			}
	})
	// const btns = (!!baixar&&<BaixarSalvarCertificado certificado_id={certificado_id}/>) || []
	const btns = baixar
		? <ReivindicarBaixarSalvarCertificado reivindicar={values.reivindicar} certificado_id={certificado_id} baixar={baixar}/>
		: <BtnDj
			lista={ [ {
				texto : "Baixar Certificado",
				onClick: ()=>setBaixar(true),
			}]}
			/>;

	return <>
		{btns}
		<label className="form-label">
			<FormInput type={"checkbox"}
				name={"reivindicar"}
				value={values.reivindicar}
				handleChange={handleChange}
				className="form-input-check"
			/>
			{" Desejo associar este certificado a minha conta InovOnline"}
		</label>
	</>
}

function ReivindicarBaixarSalvarCertificado({certificado_id, reivindicar, baixar}){
	const {
		data: certificado_data,
		isLoading, error
	} = useFind(`user/reivindicar_certificado/${certificado_id}/?reivindicar=${!!reivindicar}&baixar=${baixar}`)

	if (isLoading){
		return (
			<BtnDj
				lista={[ { texto:"Baixando...", bloquado:true} ]}
			/>
		)
	}

	if (error){
		return ( <>
			{!!error.messages
				? <Error error={error.messages}/>
				: <Error error={error}/>}
			<BtnDj
				lista={[ { texto:"Falha ao baixar", bloquado:true } ]}
			/>
		</> )
	}
	const {certificado} = certificado_data;
	return (
		<>
			<BtnDj
				lista={[ {
					texto:"Salvar Certificado",
					to: certificado.url,
					className: "baixar"
				} ]}
			/>
			<p>{`info: ${certificado_data.messages}`}</p>
		</>
	)
}
